{
  "title": "Nondetection",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level abjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a pinch of diamond dust worth 25 gp sprinkled over the target, which the spell consumes)",
  "duration": "8 hours",
  "description": [
    "For the duration, you hide a target that you touch from divination magic. The target can be a willing creature or a place or an object no larger than 10 feet in any dimension. The target can’t be targeted by any divination magic or perceived through magical scrying sensors."
  ],
  "spellLists": ["bard", "eldritch-knight", "ranger", "wizard"]
}
